import { connect } from 'react-redux';
import { StoreState } from '../../reducers';

import Editor from '../../components/Editor';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		editor: {
			type,
			previewPages,
			slider: { page },
			isEditorLoaded,
			combo: { isCombining, percentage },
		},
	} = state;
	const { params: { clientId, resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];
	const isPreviewPage = previewPages.includes(page);

	return {
		type,
		clientId: +clientId,
		resourceId: +resourceId,
		isEditorLoaded,
		isPreviewPage,
		isCombining,
		comboPercentage: percentage,
	};
};

export default connect(mapStateToProps)(Editor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/index.tsx